/**
 * Creates an array of elements split into groups the length of size. If collection can’t be split evenly, the final chunk will be the remaining elements.
 * @param input - The array to process
 * @param size - The length of each chunk
 * @return the new array containing chunks
 */

export const chunk = <T>(input: T[], size: number = 1): T[][] => {
    const sanitizedSize = size < 1 ? 1 : size;

    return input.reduce((arr, item, index) => {
        return index % sanitizedSize === 0
            ? [...arr, [item]]
            : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
    }, [] as T[][]);
};
